import React from 'react';

import fanZoneIndicator from '../../../assets/icons/fanzone-indicator-icon.svg';
import './FanZoneIndicator.css';


const FanZoneIndicator = () => (
  <div className="fan-zone-indicator">
    <img className="fan-zone-indicator__icon" src={fanZoneIndicator} />
  </div>
);

export default FanZoneIndicator;
